import React from 'react'
import Link from '@material-ui/core/Link'
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded'
import { makeStyles, Typography } from '@material-ui/core'
import { useIntl } from 'react-intl'
import './header-links.css'

const useStyles = makeStyles((theme) => ({
  linkTextSeparator: {
    float: 'left',
    fontSize: 10,
    color: theme.palette.secondary.contrastText,
  },
  headerLinks: {
    float: 'left',
    paddingTop: '0.19rem',
    display: 'flex',
  },
  headerLinksSecondary: {
    float: 'left',
    paddingTop: '0.19rem',
    marginRight: '0.75rem',
    display: 'flex',
    flexDirection: 'row',
  },
  headerLinkContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  linkText: {
    display: 'flex',
    color: theme.palette.headerLinks.text,
    '&:hover': {
      textDecoration: 'none !important',
      cursor: 'pointer',
      color: `${theme.palette.headerLinks.hover} !important`,
    },
  },
  spanBracket: {
    marginRight: theme.spacing(1),
  },
}))

const HeaderLinks = () => {
  const classes = useStyles()
  const intl = useIntl()
  const linkText = `${intl.formatMessage({ id: 'returnToOriginalWeb' })}`
  const urlParams = new URLSearchParams(window.location.search)
  const redirectUrl = urlParams.get('redirect_uri')

  return (
    <div className={classes.headerLinkContainer}>
      {!!redirectUrl && (
        <Link href={redirectUrl} aria-label={'name'}>
          <div className={classes.linkText}>
            <span className={classes.spanBracket}>
              <KeyboardBackspaceRoundedIcon />
            </span>
            <Typography variant={'body1'}>{linkText}</Typography>
          </div>
        </Link>
      )}
    </div>
  )
}

export default HeaderLinks
